import { render, staticRenderFns } from "./FormSettingsEditor.vue?vue&type=template&id=5ae1f6e0"
import script from "./FormSettingsEditor.vue?vue&type=script&lang=js"
export * from "./FormSettingsEditor.vue?vue&type=script&lang=js"
import style0 from "./FormSettingsEditor.vue?vue&type=style&index=0&id=5ae1f6e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports